import React, { Component } from 'react';
import { GenericOption } from 'com-gyf-webcore-userinterfacecomponents';

let keyWasPressed = false;

class BusquedaArchivos extends Component {
    constructor(props) {
        super(props);

        this.limpiarFiltro = this.limpiarFiltro.bind(this);
        /* this.focusInput = this.focusInput.bind(this); */
    }

    onPasteText(e) {
        e.preventDefault();
        e.nativeEvent.stopImmediatePropagation();
    }

    limpiarFiltro() {
        this.props.setBusquedaArchivos('');
        this.props.addArchivoEjecucionDemanda();
    }

/*     focusInput() {
        document.getElementById("txtBusquedaNombreArchivo").click();
    } */

    addArchivo = (event) => {
        const { listaArchivos, archivoExtension } = this.props;

        let archivos = listaArchivos && listaArchivos.length > 0 && archivoExtension ? listaArchivos?.filter(x => x.NombreArchivo.toUpperCase().substring(x.NombreArchivo.length - archivoExtension.length).includes(archivoExtension.toUpperCase())) : listaArchivos;

        if(archivos && archivos.length > 0) {
            let term = event.target.value.toString().toLowerCase();
            let showErrorMessage = term != "" ? "No se encontraron resultados" : term;
            let archivoEncontrado = undefined;

            archivoEncontrado = term != "" ?
                archivoEncontrado = listaArchivos && listaArchivos.filter(x => (x.NombreArchivo || "").toString().toLowerCase() == (term || "").toString().toLowerCase())
            :
                archivoEncontrado;

            if (archivoEncontrado && archivoEncontrado.length == 1 && !keyWasPressed) {
                this.props.addArchivoEjecucionDemanda(archivoEncontrado[0].NombreArchivo, undefined);

                this.props.setBusquedaArchivos(archivoEncontrado[0].NombreArchivo);
            }
            else {
                this.props.setBusquedaArchivos(event.target.value);
                this.props.addArchivoEjecucionDemanda(undefined, showErrorMessage);
            }

            keyWasPressed = false;
        }
    }

    keyDown = (event) => {
        //backspace = 8, tab = 9, enter = 13, ctrol = 17, shift = 16, alt = 18, [left = 37, up = 38, rigth = 39, down = 40] (flechas)
        //=> no se deben considerar como tecla presionada

        let keyNotAllowed = [8, 9, 13, 16, 17, 18, 37, 38, 39, 40];

        if (keyNotAllowed.indexOf(event.keyCode) < 0) {
            keyWasPressed = false;
        }
    }

    onFocus = (event) => {
        keyWasPressed = false;
    }

    onKeyPress = (event) => {
        let regExp = /[a-z0-9.-_ ]/ig;

        if (!regExp.test(event.key)) {
            event.preventDefault();
        }
    }

    render() {
        const { placeholder, listaArchivos, archivoExtension, textArchivo } = this.props;
        
        let optionsArchivos = listaArchivos && listaArchivos.length > 0 && listaArchivos.map(function (archivo) {
            return (
                <GenericOption id={archivo.NombreArchivo} description={archivo.NombreArchivo} key={archivo.NombreArchivo} />
            );
        });

        //En el caso de tener parametrizado una Extensión, se ignora si es mayúscula o minúscula y se valida únicamente los caracteres finales, correspondientes a la extensión.
        optionsArchivos = optionsArchivos && archivoExtension ? optionsArchivos?.filter(x => x.key?.toUpperCase().substring(x.key.length - archivoExtension?.length).includes(archivoExtension?.toUpperCase())) : optionsArchivos;

        return (
            <div>
                <input list="archivosList" id="txtBusquedaNombreArchivo"
                    className="textbox-rectangular form-control default-input top-separator-xxxs bottom-separator-xxs Procesos-BusquedaArchivoEjecDemanda"
                    value={textArchivo}
                    maxLength="50"
                    onChange={this.addArchivo}
                    onKeyDown={this.keyDown}
                    onFocus={this.onFocus}
                    onKeyPress={(e) => this.onKeyPress(e)}
                    onPaste={this.onPasteText}
                    placeholder={optionsArchivos && optionsArchivos.length > 0 ? placeholder : "No hay archivos para seleccionar"} />
                <input id="textArchivo" type="hidden" />
                {textArchivo.length > 0 ? 
                    <div className="btn-group-BusquedaArchivo-BotonBorrar">
                        <button id={"botonBorrarFiltroBuscarArchivo"} type="button" className="btn-tag Procesos-BusquedaArchivoEjecDemanda-Limpiar-Filtro"
                            onClick={this.limpiarFiltro}>
                            <span id={"botonBorrarXFiltroBuscarArchivo"} className="ti-close span-closable" />
                        </button>
                    </div>
                :
                    null}

                {optionsArchivos ?
                    <div className="row">
                        <div className="col-xs-6">
                            <datalist id="archivosList">
                                {optionsArchivos}
                            </datalist>
                        </div>
                    </div>
                :
                    null}
            </div>
        );
    }
}

export default BusquedaArchivos;